// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Table.ClientsTable {
  --border: 1px solid rgba(0, 0, 0, 0.15);
  width: 100%;
  min-height: calc(100vh - var(--header-height));
}
.Table.ClientsTable table {
  --sp-table-header-bg: var(--bs-secondary-subtle);
  background-color: #fff;
  border-width: 1px 0;
}
.Table.ClientsTable table .TableRow {
  display: grid;
  grid-template-columns: 3rem minmax(8rem, 1fr) minmax(6rem, 0.75fr) minmax(8rem, 0.75fr) minmax(10rem, 1fr) 9rem 8rem 7rem;
  width: 100%;
}
.Table.ClientsTable table .TableRow + .TableRow {
  border-top: var(--border);
}
.Table.ClientsTable table .TableRow.selected {
  background-color: var(--bs-primary-bg-subtle);
}
.Table.ClientsTable table .TableRow.TableRow-Header {
  border-bottom: var(--border);
}
.Table.ClientsTable table .TableRow.TableRow-Header .TableCell-Content {
  display: flex;
  justify-content: center;
  align-items: center;
}
.Table.ClientsTable table .TableRow .TableCell + .TableCell {
  border-left: var(--border);
}
.Table.ClientsTable table .TableRow .TableCell .TableCell-Content {
  padding: 0.35rem;
  align-content: center;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 700;
}
.Table.ClientsTable table .TableRow .TableCell .TableCell-Content .SwitchInput {
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/features/Clients/components/ClientsTable/styles.scss"],"names":[],"mappings":"AAEA;EACE,uCAAA;EACA,WAAA;EACA,8CAAA;AADF;AAGE;EACE,gDAAA;EACA,sBAAA;EACA,mBAAA;AADJ;AAGI;EACE,aAAA;EACA,yHACE;EAQF,WAAA;AATN;AAUM;EACE,yBAAA;AARR;AAWM;EACE,6CAAA;AATR;AAYM;EACE,4BAAA;AAVR;AAWQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AATV;AAcQ;EACE,0BAAA;AAZV;AAcQ;EACE,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAZV;AAaU;EACE,uBAAA;AAXZ","sourcesContent":["@import '../../../../globals.scss';\n\n.Table.ClientsTable {\n  --border: 1px solid rgba(0, 0, 0, 0.15);\n  width: 100%;\n  min-height: calc(100vh - var(--header-height));\n\n  table {\n    --sp-table-header-bg: var(--bs-secondary-subtle);\n    background-color: #fff;\n    border-width: 1px 0;\n\n    .TableRow {\n      display: grid;\n      grid-template-columns: // COLUMN WIDTHS\n        3rem // SELECT\n        minmax(8rem, 1fr) // NAME\n        minmax(6rem, 0.75fr) // DISPLAY_NAME\n        minmax(8rem, 0.75fr) // CONTACT_PERSON\n        minmax(10rem, 1fr) // PRIMARY_EMAIL\n        9rem // PRIMARY_PHONE\n        8rem // TYPE\n        7rem; // ACTIVE\n      width: 100%;\n      + .TableRow {\n        border-top: var(--border);\n      }\n\n      &.selected {\n        background-color: var(--bs-primary-bg-subtle);\n      }\n\n      &.TableRow-Header {\n        border-bottom: var(--border);\n        .TableCell-Content {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n        }\n      }\n\n      .TableCell {\n        + .TableCell {\n          border-left: var(--border);\n        }\n        .TableCell-Content {\n          padding: 0.35rem;\n          align-content: center;\n          text-align: center;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          font-weight: 700;\n          .SwitchInput {\n            justify-content: center;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
